import WebsiteIcon from 'Components/Atoms/Icons/WebsiteIcon/WebsiteIcon';
import Title from 'Components/Atoms/Title/Title';
import TitleGroup from 'Components/Molecules/TitleGroup/TitleGroup';
import { DetailedHTMLProps, HTMLAttributes } from 'react';
import styles from './FormGroup.module.sass';

const FormGroup = ({
    title,
    children,
    
    isTitle,
    isPublic,
    isRequired,

    iconBefore,
    iconAfter
}: Props) => {

    return <div className={styles['formgroup']}>
        { title && <TitleGroup
            iconBefore={iconBefore}
            iconAfter={<>
                { isPublic && <WebsiteIcon /> }
                { iconAfter }
            </>}
        >
            <Title
                size='xsmall'
                weight='semibold'
                transform='uppercase'
                color='secondary'
            >
                { title } { isRequired ? <span className={styles['formgroup--required']}>*</span> : '' }
            </Title>
        </TitleGroup> }
        { children }
    </div>;
}

interface Props extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    title?: string
    
    isTitle?: boolean
    isPublic?: boolean
    isRequired?: boolean

    iconBefore?: any
    iconAfter?: any
}

export default FormGroup;